(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.kafHeader = {
    attach: context => {
      const header = context.querySelector('.header');

      if (!header) {
        return;
      }

      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (y > 100) {
          $('.site-logo').addClass('transform-logo');
          $('.search-sticky-header--container').addClass('transform-container');
          $('.header-subnav').addClass('subnav-border');
        } else {
          $('.site-logo').removeClass('transform-logo');
          $('.search-sticky-header--container').removeClass('transform-container');
          $('.header-subnav').removeClass('subnav-border');
        }
      });
    },
  };
})(jQuery, Drupal);
